export class FetchCountries {
  static readonly type = '[Shared] Fetch countries';
}
